import React from "react";

interface ToastProps {
  title: string;
  message: string;
  onClose: () => void;
}

const toastContainer: React.CSSProperties = {
  position: "fixed",
  top: "20px",
  right: "20px",
  zIndex: 9999,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const toastStyle: React.CSSProperties = {
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: "8px",
  padding: "12px 16px",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  width: "300px",
  cursor: "pointer",
  transition: "transform 0.3s ease, opacity 0.3s ease",
};


export const Toast: React.FC<ToastProps> = ({ title, message, onClose }) => {
  return (
    <div style={toastStyle} onClick={onClose}>
      <div style={{ fontWeight: "bold", marginBottom: "4px" }}>{title}</div>
      <div>{message}</div>
    </div>
  );
};

export const ToastContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={toastContainer}>{children}</div>
);

export default Toast;